<template>
    <!-- The Modal -->
    <b-modal
        v-if="$userCan('fav_list')"
        id="favouriteTag"
             title="Add to list"
             v-model="modalOpen"
             ok-only
             no-fade
             @change="onModalChange"
             @hide="onModalChange"
             @show="onModalChange">
        <template v-slot:modal-ok>
            Close
        </template>
        <div @keydown="onKeyDown">
            <div class="row">
                <div class="col-md-12">
                    <ul class="favourite-tags">
                        <li v-for="(item, i) in tags">
                            <span
                                class="tag-name"
                                :class="isVehicleAdded(item.vehicles) ? 'active' : ''"
                                @click="toggleMapping(item, $event)"
                                :title="i > 8 ? '' : `Press ${i+1} to quickly add to list and close popup.`"
                            >
                                {{ i+1 }}. {{ item.name}}
                            </span>
                        </li>
                    </ul>
                </div>
            </div>
            <div class="row create-new-tag">
                <input
                    ref="tag_name"
                    type="text"
                    id="tag_name"
                    placeholder="List Name"
                    v-model="tag_name"
                    class="form-control"
                />&nbsp;<a class="btn btn-primary" @click.prevent="addNewFavoriteTag()">Create new</a>
            </div>
        </div>
    </b-modal>
</template>
<script>
    import {mapState, mapActions} from 'vuex'
    import {objLookup} from '../util/common'

    export default {
        props: [
            'vehicleId',
            'value',
            'date'
        ],
        mounted() {
            const args = {}
            if (this.date) {
                args.date = this.date
            }
            this.$store.dispatch('favouriteTags/maybeGetTags', {args});

            window.addEventListener('keydown', this.onKeyDown);
        },
        destroyed(){
            window.removeEventListener('keydown', this.onKeyDown);
        },
        data() {
            return {
                sort_by: 'created_at',
                sort_desc: true,
                modalOpen: this.value ? true : false,
                selected_search: null,
                fields: [
                    {label: '', key: 'checkbox'},
                    {label: 'Name', key: 'name'},
                ],
                tag_name: [],
                createList: true,
                creteListForm: false

            }
        },
        computed: {
            ...mapState({
                tags: state => state.favouriteTags.all,
                total: state => state.favouriteTags.total,
            }),
        },
        watch: {
            value(){
                this.modalOpen = !!this.value;
            }
        },
        methods: {
            onKeyDown(e) {
                if (this.modalOpen && e.target.nodeName.toLowerCase() !== 'input') {
                    let matched = e.key.match(/[1-9]/)
                    if (matched) {
                        let index = parseInt(matched[0])-1;
                        if (this.tags && this.tags[index]) {
                            let item = this.tags[index]
                            this.toggleMapping(item)
                            this.modalOpen = false

                        }
                    }
                }
            },
            onModalChange(){
                this.$emit('input', this.modalOpen);
            },
            objLookup(obj, key) {
                return objLookup(obj, key);
            },
            addNewFavoriteTag() {
                if (this.tag_name) {
                    this.$store.dispatch('favouriteTags/storeFavoriteTag', {
                        name: this.tag_name,
                    }).then(data => {
                        this.$store.dispatch('favouriteTags/getTags', {});
                    });
                }
                this.tag_name = '';
                this.createList = true;
                this.creteListForm = false;
            },
            async toggleMapping(item, event = null){
                const active_tags = this.getActiveTags()
                let emit_data = {
                    tag_id: item.id,
                    vehicle_id: this.vehicleId
                };
                if (this.isVehicleAdded(item.vehicles)) {
                    emit_data.tags_left = active_tags.length - 1
                    emit_data.removed = true
                    this.$emit('removed', emit_data)
                    this.$emit('changed', emit_data)
                } else {
                    emit_data.removed = false
                    this.$emit('added', emit_data)
                    this.$emit('changed', emit_data)
                }
                if (this.isVehicleAdded(item.vehicles)) {
                    if (event && event.target) {
                        event.target.classList.remove('active')
                    }
                    let res = await this.$store.dispatch('favouriteTags/deleteTagMapping', {
                        tag_id: item.id,
                        vehicle_id: this.vehicleId
                    });
                } else {
                    if (event && event.target) {
                        event.target.classList.add('active')
                    }
                    await this.$store.dispatch('favouriteTags/storeFavoriteTagMapping', {
                        favourite_tag_id: item.id,
                        vehicle_id: this.vehicleId,
                    });
                }
                this.$store.dispatch('favouriteTags/getTags');
            },
            createNewList() {
                this.createList = false;
                this.creteListForm = true;
                this.$nextTick(() => {
                    this.$refs['tag_name'].focus();
                })
            },
            getActiveTags(){
                const active_tags = []
                this.tags.forEach(tag => {
                    if (this.isVehicleAdded(tag.vehicles)) {
                        active_tags.push(tag)
                    }
                })
                return active_tags
            },
            isVehicleAdded(vehicles) {
                if (vehicles) {
                    return vehicles.some(added => {
                        if (added.api_id === this.vehicleId) {
                            return true;
                        }
                    });
                }
                return false;
            }
        },
    }
</script>



// WEBPACK FOOTER //
// resources/js/components/FavouriteTagModal.vue